import { UploadedStatus } from './UploadedStatus'

export default UploadedStatus
